@let showInfoDiv = (userStatusValue === enumUserStatus.MaxLoginsReached);

<div id="alertMessage"
     class="ez-alert warn">
  <mat-icon color="warn">report</mat-icon>

  <div class="error-text">
    @if (isAutomationUser()) {
  <div>Automation Users are not allowed to log into the application.</div>
} @else if (badLogInAttempt().mfaEnrollmentRequired) {
  <div>
    Your account requires multi-factor authentication enrollment.
    Please log in <a href="{{ legacyLoginUrl() }}">here to continue.</a>
  </div>
} @else if (loginStatusValue === enumLoginStatus.Locked) {
  <div>Your account is locked and cannot be accessed.</div>
} @else if (loginStatusValue === enumLoginStatus.SsoDisabled) {
  <div>{{ ssoClientName }} SSO is currently disabled. Log in with your EZLynx credentials.</div>
} @else {
  @switch (userStatusValue) {
    @case (enumUserStatus.MaxLoginsReached) {
      <div>
        Your account is limited to <b>{{ badLogInAttempt().maxLoginsAllowed }}</b> active
        session{{ badLogInAttempt().maxLoginsAllowed > 1 ? 's' : '' }} at a time.
      </div>
    }

    @case (enumUserStatus.Disabled || userStatusValue === enumUserStatus.Deleted) {
      <div>Your account is disabled.</div>
    }

    @case (enumUserStatus.ExpiredTrial) {
      <div>Trial Account access has expired.</div>
    }

    @case (enumUserStatus.Expired) {
      <div>Organization Access has expired.</div>
    }

    @case (enumUserStatus.UnauthorizedNetwork) {
      <div>Login Failed - Unauthorized network access.</div>
    }

    @default {
      @if (badLogInAttempt().badLoginAttemptCount >= maxBadLoginAttempts - 2) {
        <div>
          @let remainingAttempts = maxBadLoginAttempts - badLogInAttempt().badLoginAttemptCount;
                  Warning. You have {{ remainingAttempts === 2 ? '2 more attempts' : '1 more attempt' }} before you have to reset your password.
        </div>

        <div>
          Please click the <a href="{{ forgotPasswordUrl() }}">Forgot Password?</a> link to reset your password.
        </div>
      } @else {
        <div>The login attempt failed. The credentials entered are invalid.</div>
      }
      }
      }
      }
      </div>
      </div>

      @if (showInfoDiv) {
        <div class="mdc-layout-grid_inner">
          <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
            <p>You may continue to log in by entering your password and pressing the 'Continue' button below.</p>
            <p>Doing this will log out the session that is currently active.</p>
          </div>
        </div>
      }